import { render } from "./AboutChatbot.vue?vue&type=template&id=a2827b72"
import script from "./AboutChatbot.vue?vue&type=script&lang=js"
export * from "./AboutChatbot.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__